import { onReady } from '@/core/utils/dom';
import { getProperties } from './data/event.utils.client';
import { init as privacyInit } from './privacy/privacy.init.client';
import { ANALYTICS_EVENTS } from './tracking/events.config';
import { track } from './tracking/tag-manager.adapter.client';

function init(): void {
	onReady(() => {
		getProperties().then((properties) => {
			track({ type: ANALYTICS_EVENTS.userContext, ...properties });
		});
	});
}

init();
privacyInit();
